module.exports = __webpack_public_path__ + "static/media/dimpos_logo.a1765727.png";